import { useQuery } from '@tanstack/react-query';
import { Assento, AvisoPoltrona, Passagem } from '../../utils/interfaces';
import { api } from '../../libs/axios';
import Swal from 'sweetalert2';

interface useProps {
  passagem?: Passagem
}

export interface LayoutData {
  assentos: Assento[];
  mensagemServico: string;
  devolucaoPresencial: boolean;
  avisoDevolucaoPresencial: string | null;
  avisos: AvisoPoltrona[];
  preco?: number;
  precoBase?: number;
  embarque?: string;
  saidaDia?: string;
  saidaHora?: string;
}

async function getLayout({ passagem }: useProps): Promise<LayoutData> {
  const response = await api
    .get('passagens/detalhar', {
      params: {
        origem: passagem?.origem,
        destino: passagem?.destino,
        data: passagem?.dataViagem,
        cidadeOrigemId: passagem?.cidadeOrigemId,
        cidadeDestinoId: passagem?.cidadeDestinoId,
        servico: passagem?.servico,
        grupo: passagem?.grupo,
        classe: passagem?.classe,
        precoBase: passagem?.precoBase,
        busCompany: passagem?.empresa,
        adaptador: passagem?.adaptador,
        servico_id: passagem?.servico,
        viacao_id: passagem?.viacao?.id,
        provedorWebviagem: passagem?.provedorWebviagem
      },
    })
    .then((res) => res.data)
    .catch(() => {
      Swal.fire({
          toast: false,
          position: "center",
          showConfirmButton: true,
          icon: 'error',
          text: 'Tente novamente mais tarde ou escolha outro horário disponível.',
          title: 'Erro ao buscar poltronas',
        })
    });

  const mensagemServico = typeof response?.data?.mensagemServico === 'string'
    ? response.data.mensagemServico
    : '';
  const avisos: AvisoPoltrona[] = Array.isArray(response?.data?.avisos)
    ? response.data.avisos
    : [];

  const assentos: Assento[] = response.data.assentos.map((item: Assento) => ({
    ...item,
    servico: response.data.servico,
  }));

  return {
    assentos,
    mensagemServico,
    devolucaoPresencial: Boolean(response.data.devolucaoPresencial),
    avisoDevolucaoPresencial: typeof response.data.avisoDevolucaoPresencial === 'string'
      ? response.data.avisoDevolucaoPresencial
      : null,
    avisos,
    preco: response.data.preco,
    precoBase: response.data.precoBase,
    embarque: response.data.embarque,
    saidaDia: response.data.saidaDia,
    saidaHora: response.data.saidaHora,
  };
}

export function useLayout({ passagem }: useProps) {
  return useQuery({
    queryKey: ['layout', {passagem}],
    queryFn: typeof passagem !== 'undefined' ? () => getLayout({ passagem }) : undefined,
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
  })
}
